import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { App } from "./app/App";
import { startVersionWatcher } from "./versionWatcher";
import { migrateLegacyAppPushRegistration } from "./pwa/push";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

// Warm up the root service worker early so it is active by the time the user
// reaches Settings → Enable push. iOS Home Screen web apps need the worker to
// control the page before subscribe() works, and the first activation can lag.
const serviceWorkerRegistration = "serviceWorker" in navigator
  ? navigator.serviceWorker.register("/service-worker.js", {
    scope: "/",
    updateViaCache: "none"
  }).then(async (registration) => {
    await migrateLegacyAppPushRegistration(registration);
    return registration;
  }).catch(() => null)
  : Promise.resolve(null);

startVersionWatcher({
  loadedVersion: __APP_VERSION__,
  serviceWorkerRegistration
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
